import { v4 as uuidv4 } from 'uuid'
import { findIndex, isEmpty } from 'lodash-es'
import moment from 'moment'
import { budgetFormat } from '../../../utils/formatterUtil'

export const totalData = {
  id: uuidv4(),
  list: 'รวมจำนวนเงิน',
  cost: 0,
  isTotal: true,
}

export const getExpandedId = (_data) => {
  if (isEmpty(_data)) {
    return
  }
  let detailIds = []

  let ids = _data.map((item) => {
    detailIds.push(item?.children[item.children.length - 1].id)
    return item.id
  })
  return [...ids, ...detailIds]
}

export const getExpandedAllId = (_data) => {
  if (isEmpty(_data)) {
    return
  }
  let detailIds = []

  let ids = _data.map((item) => {
    item.children.map((itemChildren) => {
      detailIds.push(itemChildren.id)
    })

    return item.id
  })
  return [...ids, ...detailIds]
}

export const convertTableData = (_data, _isEditable, initialData) => {
  return _data.map((item) => {
    const detailData = {
      id: uuidv4(),
      list: 'รายละเอียดผลงาน',
      children: [
        {
          id: item.detail?.id || uuidv4(),
          list: item.detail?.value || '',
          isDetail: true,
        },
      ],
    }

    let children = !isEmpty(item.children) ? item.children : []
    let totalVat = 0

    children.forEach((item) => {
      totalVat += item.vat || 0
    })

    if (!isEmpty(initialData)) {
      children = initialData.map((costItem) => {
        const existDataIndex = findIndex(children, { id: costItem.id })
        let cost = 0
        let vat = 0
        let tax = 0

        if (existDataIndex > -1) {
          cost = children[existDataIndex].cost
          vat = children[existDataIndex].vat
          tax = children[existDataIndex].tax
        }

        return {
          id: costItem.id,
          label: costItem.name,
          cost,
          vat,
          tax,
//          cost: budgetFormat(cost),
//          vat: budgetFormat(vat),
//          tax: budgetFormat(tax),
          enableVat: costItem.enableVat,
        }
      })
    }

    return {
      ...item,
      vat: totalVat,
      children: [...children, detailData],
    }
  })
}

export const convertTablePlannedDisbursementData = (_dataMaster, _isEditable, initialData) => {
  return _dataMaster.map((item) => {
    let children = !isEmpty(item.masterPlan?.children) ? item.masterPlan?.children : []
    let totalVat = 0

    children.forEach((item) => {
      totalVat += item.vat || 0
    })

    if (!isEmpty(initialData)) {
      children = initialData.map((costItem) => {
        const existDataIndex = findIndex(children, { id: costItem.id })
        let cost = 0
        let vat = 0
        let tax = 0

        if (existDataIndex > -1) {
          cost = children[existDataIndex].cost
          vat = children[existDataIndex].vat
          tax = children[existDataIndex].tax
        }

        return {
          id: costItem.id,
          label: costItem.name,
          cost,
          vat,
          tax,
          enableVat: costItem.enableVat,
        }
      })
    }

    return {
      ...item.masterPlan,
      vat: totalVat,
      children: [...children],
      masterCost: item.cost
    }
  })
}

export const subProjectConvertTableData = (_data, _isEditable, initialData) => {
  return _data.map((item) => {
    // const detailData = {
    //   id: uuidv4(),
    //   list: 'รายละเอียดผลงาน 11',
    //   children: [
    //     {
    //       id: item.detail?.id || uuidv4(),
    //       list: item.detail?.value || '',
    //       isDetail: true,
    //     },
    //   ],
    // }

    let children = !isEmpty(item.children) ? item.children : []
    let totalVat = 0

    children.forEach((item) => {
      totalVat += item.vat || 0
    })

    if (!isEmpty(initialData)) {
      children = initialData.map((costItem) => {
        const existDataIndex = findIndex(children, { id: costItem.id })
        let cost = 0
        let vat = 0
        let withholdingTax = 0

        if (existDataIndex > -1) {
          cost = children[existDataIndex].cost
          vat = children[existDataIndex].vat
          withholdingTax = children[existDataIndex].withholdingTax
        }

        return {
          id: costItem.id,
          label: costItem.list,
          cost,
          vat,
          withholdingTax,
          enableVat: costItem.enableVat,
          ...costItem,
        }
      })
    }

    //replace children: [] to null, list: null to ""
    children?.forEach((element, index) => {
      if (element.children?.length > 0) {
        element.children?.forEach((element2, index2) => {
          if (element2.children?.length === 0) {
            children[index].children[index2].children = null
          }
          if (element2.isDetail && !element2.list) {
            children[index].children[index2].list = ''
          }
        })
      }
    })

    return {
      ...item,
      vat: totalVat,
      // children: [...children, detailData],
      children: [...children],
    }
  })
}

export const initialNewData = (initialData, initialInstallment, tableData) => {
  const addedChildrenData = initialData.map((item) => {
    return {
      id: item.id,
      label: item.name,
      cost: 0,
      vat: item.vat,
      tax: item.tax,
      enableVat: item.enableVat,
    }
  })

  const numberOfInstallmentIndex = !isEmpty(tableData) ? tableData.length : 0
  return {
    id: initialInstallment[numberOfInstallmentIndex].id,
    list: initialInstallment[numberOfInstallmentIndex].name,
    numberOfInstallment: numberOfInstallmentIndex + 1,
    cost: 0,
    startDate: null,
    endDate: null,
    date: null,
    year: null,
    status: 'EDIT',
    children: [
      ...addedChildrenData,
      {
        id: uuidv4(),
        list: 'รายละเอียดผลงาน',
        children: [
          {
            id: uuidv4(),
            list: '',
            isDetail: true,
          },
        ],
      },
    ],
  }
}

export const subProjectInitialNewData = (initialData, initialInstallment, tableData) => {
  const addedChildrenData = initialData.map((item) => {
    return {
      id: item.id,
      list: item.list,
      cost: 0,
      children: item.children.map((item2) => {
        return {
          id: item2.id,
          list: item2.isDetail ? '' : item2.list,
          cost: 0,
          isDetail: item2.isDetail,
          withholdingTax: 0,
        }
      }),
    }
  })

  const numberOfInstallmentIndex = !isEmpty(tableData) ? tableData.length : 0

  let newData = {
    id: initialInstallment[numberOfInstallmentIndex].id,
    list: initialInstallment[numberOfInstallmentIndex].name,
    numberOfInstallment: numberOfInstallmentIndex + 1,
    cost: 0,
    startDate: null,
    endDate: null,
    date: null,
    year: null,
    status: 'EDIT',
    children: addedChildrenData,
    isNewVersion: true
  }

  return newData
}

export const getTotalSummary = (_tableData) => {
  return _tableData.reduce((pre, cur) => {
    if (cur.cost && !cur.isTotal) {
      return pre + cur.cost
    }
    return pre
  }, 0)
}

export const getNewDataEditYearAndDate = (
  tableData,
  rowData,
  year,
  date,
  startDate,
  endDate,
  cost,
  isEditValue
) => {
  const nextData = Object.assign([], tableData)
  const index = findIndex(nextData, { id: rowData.id })
  const activeItem = nextData[index]

  activeItem.status = activeItem.status ? null : 'EDIT'
  if (isEditValue) {
    activeItem.year = year
    activeItem.date = moment(date).format('DD/MM/YYYY')
    activeItem.startDate = moment(startDate).format('DD/MM/YYYY')
    activeItem.endDate = moment(endDate).format('DD/MM/YYYY')
  }
  if(cost){
    activeItem.cost = cost || 0
  }

  return nextData
}

export const getNewCostDataEditState = (tableData, rowData, value, isEditValue) => {
  const nextData = Object.assign([], tableData)
  const parentIndex = findIndex(nextData, { id: rowData._parent.id })
  if (parentIndex === -1) {
    return
  }
  const activeItem = nextData[parentIndex].children.find((item) => item.id === rowData.id)
  activeItem.status = activeItem.status ? null : 'EDIT'
  if (isEditValue) {
    activeItem.cost = value ? parseFloat(parseFloat(value[1]).toFixed(2)) : 0

    let totalCost = activeItem._parent.children.reduce((pre, cur) => {
      if (cur.cost) {
        return pre + cur.cost
      }
      return pre
    }, 0)

    activeItem._parent.cost = totalCost
    //activeItem._parent.withholdingTax = totalCost * 0.01

    activeItem?._parent?.children?.forEach((item, index) => {
      if (activeItem._parent.children[index].isVatCalculate) {
        let vatRate = activeItem._parent.children[index].vatRate || 0
        let cost = activeItem._parent.children[index].cost || 0

        //cal tax for render
        activeItem._parent.children[index].withholdingTax = cost * (vatRate / 100)
      }
    })

    // cost: 10000
    // id: "49603EAC-2374-4E4D-B09B-60184F8B49EF"
    // isVatCalculate: false
    // label: "เงินสนับสนุนโครงการ"
    // vat: 0
    // vatRate: 0
    // withholdingTax: 0

    activeItem.vat = value ? parseFloat(parseFloat(value[0]).toFixed(2)) : 0
    activeItem._parent.vat = activeItem._parent.children.reduce((pre, cur) => {
      if (cur.vat) {
        return pre + cur.vat
      }
      return pre
    }, 0)
  }
  return nextData
}

export const getSubNewCostDataEditState = (tableData, rowData, value, isEditValue) => {
  const nextData = Object.assign([], tableData)
  //let nextData = tableData
  const parentIndex = findIndex(nextData, { id: rowData?._parent?._parent.id })
  const parentIndex2 = findIndex(nextData[parentIndex].children, { id: rowData?._parent?.id })
  const parentIndex3 = findIndex(nextData[parentIndex].children[parentIndex2].children, {
    id: rowData?.id,
  })
  if (parentIndex === -1 || parentIndex2 === -1) {
    return
  }
  const activeItem = nextData[parentIndex].children[parentIndex2].children.find(
    (item) => item.id === rowData.id
  )
  activeItem.status = activeItem.status ? null : 'EDIT'

  if (isEditValue) {
    activeItem.cost = value ? parseFloat(parseFloat(value[1]).toFixed(2)) : 0

    let totalCost = activeItem._parent.children.reduce((pre, cur) => {
      if (cur.cost) {
        return pre + cur.cost
      }
      return pre
    }, 0)

    //activeItem._parent.cost = totalCost
    nextData[parentIndex].children[parentIndex2].cost = totalCost

    if (activeItem?._parent?._parent) {
      let totalCatagoryCost = activeItem._parent._parent.children.reduce((pre, cur) => {
        if (cur.cost) {
          return pre + cur.cost
        }
        return pre
      }, 0)

      //activeItem._parent._parent.cost = totalCatagoryCost
      nextData[parentIndex].cost = totalCatagoryCost
    }
  }
  return nextData
}

export const getNewDetailDataEditState = (tableData, rowData, value, isEditValue) => {
  const nextData = Object.assign([], tableData)
  const parentIndex = findIndex(nextData, { id: rowData._parent._parent.id })
  const activeItem =
    nextData[parentIndex].children[nextData[parentIndex].children.length - 1].children[0]
  activeItem.status = activeItem.status ? null : 'EDIT'
  if (isEditValue) {
    activeItem.list = value
  }
  return nextData
}
